import { LexicalNode, $applyNodeReplacement } from 'lexical';

import { WysiwygConfigMode } from '../../WysiwygInput';

import { SingleImageNode } from './SingleImageNode';

export function $createSingleImageNode(
  alt: string,
  id: string,
  description?: string,
  mode?: WysiwygConfigMode,
): SingleImageNode {
  return $applyNodeReplacement(new SingleImageNode(alt, id, description, mode));
}

export function $isSingleImageNode(
  node: LexicalNode | null | undefined,
): node is SingleImageNode {
  return node instanceof SingleImageNode;
}
